import { render, staticRenderFns } from "./index.vue?vue&type=template&id=889ca826&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=889ca826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../16/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889ca826",
  null
  
)

export default component.exports